function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowGoUp = function SvgArrowGoUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    xmlSpace: "preserve"
  }, props), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#231f20",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "m24.3 37.6 8.9-8.9 9.1 9.1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.7 61.9H10.2c-4.5 0-8.2-3.7-8.2-8.2V10.3c0-4.5 3.7-8.2 8.2-8.2h43.5c4.5 0 8.2 3.7 8.2 8.2v43.5c0 4.4-3.7 8.1-8.2 8.1z",
    style: {
      fill: "none",
      stroke: "#231f20",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    }
  }));
};
export default SvgArrowGoUp;